import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * This (standalone) translate pipe is currently more a workaround for standalone components.
 * Eventually we might remove this again and use the translate pipe from ngx (again).
 */
@Pipe({
  name: 'translate',
})
export class TranslatePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  public transform(value: any): any {
    return this.translateService.instant(value); // TODO: consider args...
  }
}
